module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "crop_reference",
    staticClass: "container image-form"
  }, [_c('div', {
    staticClass: "columns image-form-details"
  }, [_c('div', {
    staticClass: "column is-narrow"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("\n                        " + _vm._s(_vm.create ? 'Select an image for upload' : 'Select an image to replace the old image') + "\n                    ")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "name": "imageUpload"
    },
    on: {
      "change": _vm.imageChanged
    }
  })])])]), _vm._v(" "), (_vm.imageReady) ? _c('div', {
    staticClass: "column"
  }, [_c('strong', [_vm._v("Image Details")]), _vm._v(" "), _c('br'), _vm._v("\n                " + _vm._s(_vm.width) + " x " + _vm._s(_vm.height) + "px\n                "), _c('div', {
    staticClass: "is-pulled-right"
  }, [_vm._v("\n                " + _vm._s(_vm._f("prettyBytes")(_vm.size)) + " / 50 MB\n                ")]), _vm._v(" "), _c('progress', {
    staticClass: "progress is-info",
    attrs: {
      "max": "100"
    },
    domProps: {
      "value": Math.round(_vm.size / 50000000 * 100)
    }
  }, [_vm._v("\n                    " + _vm._s(Math.round(_vm.size / 50000000 * 100)) + "%\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.imageReady) ? _c('div', {
    staticClass: "column"
  }, [_c('form-group', {
    ref: "image_name",
    attrs: {
      "type": "text",
      "label": "Image Name",
      "id": "name",
      "error": _vm.nameError
    },
    on: {
      "input": _vm.nameChanged
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.loading) ? _c('h1', {
    staticClass: "title has-text-centered"
  }, [_c('strong', [_vm._v("Loading image...")])]) : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.imageReady) ? _c('div', [(_vm.step === 'crop') ? _c('div', [_c('div', {
    staticClass: "container"
  }, [(_vm.preview !== null) ? _c('h3', {
    staticClass: "subtitle"
  }, [_c('div', {
    staticClass: "is-pulled-right"
  }, [_c('button', {
    staticClass: "button is-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.nextStep('thumbnail')
      }
    }
  }, [_vm._v("\n                            Select the thumbnail\n                        ")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.nextStep('finalize')
      }
    }
  }, [_vm._v("\n                            Review\n                             \n                            "), _c('i', {
    staticClass: "fa fa-arrow-right"
  })])]), _vm._v("\n                    Main Image Crop\n                    "), _c('br'), _vm._v(" "), _vm._m(0)]) : _vm._e()]), _vm._v(" "), (_vm.step === 'crop') ? _c('image-cropper', {
    attrs: {
      "image-data": _vm.preview,
      "start-crop": _vm.mainCrop,
      "min-size": {
        width: 200,
        height: 200
      }
    },
    on: {
      "cropped": _vm.setMainCrop
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.step === 'thumbnail') ? _c('div', [_c('div', {
    staticClass: "container"
  }, [_c('h3', [_c('div', {
    staticClass: "is-pulled-right"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.nextStep('crop')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v("\n                             \n                            Edit Main Crop\n                        ")]), _vm._v(" "), _c('button', {
    staticClass: "button is-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.nextStep('finalize')
      }
    }
  }, [_vm._v("\n                            Review\n                             \n                            "), _c('i', {
    staticClass: "fa fa-arrow-right"
  })])]), _vm._v("\n                    Thumbnail Crop\n                    "), _c('br'), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), (_vm.step === 'thumbnail') ? _c('image-cropper', {
    attrs: {
      "image-data": _vm.preview,
      "start-crop": _vm.thumbCrop || _vm.mainCrop,
      "bounds": _vm.mainCrop,
      "min-size": {
        width: 50,
        height: 50
      }
    },
    on: {
      "cropped": _vm.setThumbCrop
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.step === 'finalize') ? _c('div', [_c('div', {
    staticClass: "container"
  }, [_c('h3', {
    staticClass: "is-clearfix"
  }, [_c('div', {
    staticClass: "is-pulled-right"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.nextStep('crop')
      }
    }
  }, [_vm._v("Edit Main Crop")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.nextStep('thumbnail')
      }
    }
  }, [_vm._v("Edit Thumbnail")]), _vm._v(" "), (_vm.imageReady) ? _c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("Upload")]) : _vm._e()]), _vm._v("\n                    Review the generated sizes.\n                    "), _c('br'), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('h4', [_vm._v("Thumbnail Size")]), _vm._v(" "), _c('div', {
    staticClass: "crop-preview",
    style: ({
      width: Math.round(_vm.thumbWidth * _vm.thumbRatio) + 'px',
      height: Math.round(_vm.thumbHeight * _vm.thumbRatio) + 'px'
    })
  }, [_c('img', {
    style: ({
      width: Math.round(_vm.width * _vm.thumbRatio) + 'px',
      height: Math.round(_vm.height * _vm.thumbRatio) + 'px',
      top: -Math.round(_vm.thumbTop * _vm.thumbRatio) + 'px',
      left: -Math.round(_vm.thumbLeft * _vm.thumbRatio) + 'px'
    }),
    attrs: {
      "src": _vm.preview
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Normal Size")]), _vm._v(" "), _c('div', {
    staticClass: "crop-preview",
    style: ({
      width: Math.round(_vm.mainWidth * _vm.normalRatio) + 'px',
      height: Math.round(_vm.mainHeight * _vm.normalRatio) + 'px'
    })
  }, [_c('img', {
    style: ({
      width: Math.round(_vm.width * _vm.normalRatio) + 'px',
      height: Math.round(_vm.height * _vm.normalRatio) + 'px',
      top: -Math.round(_vm.mainTop * _vm.normalRatio) + 'px',
      left: -Math.round(_vm.mainLeft * _vm.normalRatio) + 'px'
    }),
    attrs: {
      "src": _vm.preview
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Full Size "), (_vm.mainWidth > _vm.container.width) ? _c('em', [_vm._v("(scaled to fit the page)")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "crop-preview",
    style: ({
      width: Math.round(_vm.mainWidth * _vm.mainRatio) + 'px',
      height: Math.round(_vm.mainHeight * _vm.mainRatio) + 'px'
    })
  }, [_c('img', {
    style: ({
      width: Math.round(_vm.width * _vm.mainRatio) + 'px',
      height: Math.round(_vm.height * _vm.mainRatio) + 'px',
      top: -Math.round(_vm.mainTop * _vm.mainRatio) + 'px',
      left: -Math.round(_vm.mainLeft * _vm.mainRatio) + 'px'
    }),
    attrs: {
      "src": _vm.preview
    }
  })])])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', [_c('em', [_vm._v("Crops the whole image for all sizes. Typically unnecessary for most images, however,\n                    you can use it to remove large/unnecessary padding from the edges of the image or\n                    you can use it to cutout a smaller area of the image.\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', [_c('em', [_vm._v("Crops the area that will be used for the thumbnail.\n                    The thumbnail crop can be used to enlarge details that would otherwise\n                    be too small to see when the image is scaled down to the thumbnail's maximum size of 200x200px.\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', [_c('em', [_vm._v("Upload once you are satisfied with the results.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fa84c70"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/components/forms/ImageForm.vue
// module id = 541
// module chunks = 0